import {Headers} from 'headers-polyfill';

export {Headers};
